import { render, staticRenderFns } from "./CategoriesDropdown.vue?vue&type=template&id=3ed26787&scoped=true&"
import script from "./CategoriesDropdown.vue?vue&type=script&lang=js&"
export * from "./CategoriesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesDropdown.vue?vue&type=style&index=0&id=3ed26787&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed26787",
  null
  
)

export default component.exports